<template>
  <div ref="map" style="width: 100%; height: 100%"></div>
</template>

<script>
import _ from "lodash";

function CoordMapType(tileSize, qq) {
  this.tileSize = tileSize;
  this.qq = qq;
}

CoordMapType.prototype.getTile = function (coord, zoom, ownerDocument) {
  var div = ownerDocument.createElement("div");
  div.style.width = this.tileSize.width + "px";
  div.style.height = this.tileSize.height + "px";
  div.style.fontSize = "10";
  div.style.borderStyle = "solid";
  div.style.borderWidth = "1px";
  div.style.borderColor = "rgba(150,150,150,0.25)";

  const tileXYToQuadKey = function ($tile_x, $tile_y, $zoom) {
    if ($zoom == 0) return "0";

    let $quadKey = "";
    for (let $i = $zoom; $i > 0; $i--) {
      let $digit = 0;
      let $mask = 1 << ($i - 1);
      if (($tile_x & $mask) != 0) {
        $digit++;
      }
      if (($tile_y & $mask) != 0) {
        $digit++;
        $digit++;
      }
      $quadKey = $quadKey + "" + $digit;
    }
    return $quadKey;
  };

  div.innerHTML =
    coord + "<b>" + tileXYToQuadKey(coord.x, coord.y, zoom) + "</b>";

  return div;
};

function CoordMapType2(tileSize, qq) {
  this.tileSize = tileSize;
  this.qq = qq;
}

CoordMapType2.prototype.getTile = function (coord, zoom, ownerDocument) {
  var div = ownerDocument.createElement("div");
  div.style.width = this.tileSize.width + "px";
  div.style.height = this.tileSize.height + "px";
  div.style.fontSize = "10";
  div.style.borderStyle = "solid";
  div.style.borderWidth = "1px";
  div.style.borderColor = "rgba(150,150,150,0.15)";
  return div;
};

export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        zoom: 12,
        center: {
          lat: 0,
          lng: 0,
        },
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false,
      }),
    },
    markers: {
      default: null,
    },
    active_marker: {
      default: null,
    },
    active_cluster: {
      default: null,
    },
  },

  data: () => ({
    map: null,
    google: null,
    rendered_markers: [],
    rendered_clusters: [],
    ignore_once: false,
    active_popup: null,
    rect: null,
  }),

  watch: {
    markers: {
      handler: function (markers) {
        this.renderMarkers(markers);
      },
      deep: true,
    },

    active_marker: {
      handler: function (uuid) {
        const default_symbol = {
          path:
            "M58,0H2C0.9,0,0,0.9,0,2v22c0,1.1,0.9,2,2,2h24.5c1.3,0,2.7,0,4,0c1,0,2,0,3,0H58c1.1,0,2-0.9,2-2V2C60,0.9,59.1,0,58,0z",
          fillColor: "#FFF",
          fillOpacity: 0.9,
          anchor: new google.maps.Point(30, 31),
          labelOrigin: new google.maps.Point(30, 13),
          strokeWeight: 1,
          strokeColor: "rgba(0,0,0,0.5)",
          scale: 1,
        };
        const active_symbol = {
          ...default_symbol,
          fillColor: "#000",
          scale: 1.1,
        };

        _.each(this.rendered_markers, (marker) => {
          if (marker.is_active) {
            let label = marker.getLabel();
            label.color = "#888";
            marker.setLabel(label);
            marker.setIcon(default_symbol);
          }
          if (uuid != null && marker.uuid == uuid) {
            marker.is_active = true;
            let label = marker.getLabel();
            label.color = "#FFF";
            marker.setLabel(label);
            marker.setIcon(active_symbol);
            // console.log(marker);
          }
        });
      },
      deep: true,
    },
    active_cluster: {
      handler: function (key) {
        _.each(this.rendered_clusters, (cluster) => {
          console.log(key == cluster.id);

          if (key == cluster.id) {
            console.log(key);
          }

          let def_symbol = {
            path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
            fillColor: "#e62e2e",
            fillOpacity: 0.55,
            anchor: new google.maps.Point(0, 0),
            // strokeWeight: stroke_scale,
            strokeColor: "transparent",
            scale: cluster.scale,
          };
          let marker = cluster.marker;
          if (key != null && cluster.id == key) {
            let active_symbol = {
              ...def_symbol,
              fillColor: "#000",
            };
            marker.setIcon(active_symbol);
            // console.log(marker);
          } else {
            marker.setIcon(def_symbol);
          }
        });
      },
      deep: true,
    },
  },

  mounted: function () {
    const map_events = [
      "bounds_changed",
      "center_changed",
      "click",
      "dblclick",
      "drag",
      "dragend",
      "dragstart",
      "heading_changed",
      "idle",
      "maptypeid_changed",
      "mousemove",
      "mouseout",
      "mouseover",
      "projection_changed",
      "rightclick",
      "tilesloaded",
      "tilt_changed",
      "zoom_changed",
    ];

    // ignore events on mounting
    this.ignore_once = true;

    this.$google.then((google) => {
      let element = this.$refs.map;

      this.google = google;
      this.map = new google.maps.Map(element, this.options);

      // temporary grid for debug
      if (process.env.NODE_ENV == "development") {
        this.map.overlayMapTypes.insertAt(
          0,
          new CoordMapType2(new google.maps.Size(128, 128))
        );
        this.map.overlayMapTypes.insertAt(
          0,
          new CoordMapType(new google.maps.Size(256, 256))
        );
      }

      this.$nextTick(function () {
        for (let i = 0; i < map_events.length; i++) {
          this.map.addListener(map_events[i], (e) => {
            return this.handleMapEvents(map_events[i], e, this.map);
          });
        }
      });
    });
  },

  methods: {
    once: function () {
      this.ignore_once = true;
    },

    handleMapEvents: function (name, event, map) {
      this.$emit(name, event, map);

      // Fire "change" event for handling API updates
      let watch_for = ["bounds_changed", "center_changed", "zoom_changed"];

      if (_.includes(watch_for, name)) {
        let location = {
          ...map.getBounds().toJSON(),
          ...map.getCenter().toJSON(),
          zoom: map.getZoom(),
          formatted_address: null,
          place_id: null,
        };
        // We have a huge number of fireing events...
        this.debounceChange(location);
      }
    },

    debounceChange: _.debounce(function (location) {
      if (this.ignore_once == true) {
        this.ignore_once = false;
      } else {
        return this.$emit("change", location);

        if (this.active_popup) {
          this.active_popup.close();
          this.$emit("closeMarker");
        }
      }
    }, 1000),

    renderMarkers: function (markers) {
      this.rendered_clusters = [];
      let new_markers = [];
      let max_markers = 1;
      try {
        max_markers = _.maxBy(markers, (m) => m.count).count || 1;
      } catch (e) {}

      _.forEach(markers, (record, key) => {
        let google = this.google;
        let map = this.map;

        let marker_scale = 0 + (record.count * 2) / max_markers;
        let stroke_scale = 0.5 + (record.count * 5) / max_markers;
        let marker_z_index = max_markers - record.count;

        let marker;

        if (record.is_cluster) {
          let position = new google.maps.LatLng(
            record.latitude,
            record.longitude
          );
          var symbol = {
            path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
            fillColor: "#e62e2e",
            fillOpacity: 0.55,
            anchor: new google.maps.Point(0, 0),
            // strokeWeight: stroke_scale,
            strokeColor: "transparent",
            scale: marker_scale,
          };

          marker = new google.maps.Marker({
            position: position,
            label: {
              color: "#ffffff",
              fontWeight: "bold",
              fontSize: "13px",
              text: record.count.toString(),
            },
            icon: symbol,
            zIndex: marker_z_index,
          });
          marker.addListener("mouseover", function () {
            this.setIcon({
              path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
              fillColor: "#000000",
              fillOpacity: 0.55,
              anchor: new google.maps.Point(0, 0),
              // strokeWeight: stroke_scale,
              strokeColor: "transparent",
              scale: marker_scale,
            });
          });

          // assuming you also want to hide the infowindow when user mouses-out
          marker.addListener("mouseout", function () {
            this.setIcon(symbol);
          });
          marker.addListener("click", () => {
            //let map = this.map;
            // let location = {
            //   ...map.getBounds().toJSON(),
            //   ...map.getCenter().toJSON(),
            //   zoom: map.getZoom(),
            //   formatted_address: null,
            //   place_id: null
            // };
            this.$emit("clickCluster", record);
          });
          this.rendered_clusters.push({
            id: record.prefix,
            marker: marker,
            scale: marker_scale,
          });
        } else {
          let position = new google.maps.LatLng(record.lat, record.lng);

          var symbol = {
            path:
              "M58,0H2C0.9,0,0,0.9,0,2v22c0,1.1,0.9,2,2,2h24.5c1.3,0,2.7,0,4,0c1,0,2,0,3,0H58c1.1,0,2-0.9,2-2V2C60,0.9,59.1,0,58,0z",
            fillColor: "#FFF",
            fillOpacity: 0.9,
            anchor: new google.maps.Point(30, 31),
            labelOrigin: new google.maps.Point(30, 13),
            strokeWeight: 1,
            strokeColor: "rgba(0,0,0,0.5)",
            scale: 1,
          };

          marker = new google.maps.Marker({
            position: position,
            label: {
              color: "#777",
              fontWeight: "bold",
              fontSize: "13px",
              text: `${record.price_total} ${this.trans(
                "advert.price_currency_" + record.price_currency
              )}`,
            },
            icon: symbol,
          });

          let infoWindow = new google.maps.InfoWindow({
            maxWidth: 200,
          });

          let image_url = _.get(record, "images[0].urls.sm", null);
          if (image_url) {
            image_url = this.url("media/" + image_url);
          } else {
            image_url =
              "data:image/jpeg;base64,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";
          }

          let content = `<div class="map-info-wrapper" ><div class="info-row" style="cursor:pointer;" id="infowindow-${
            record.uuid
          }"><img src="${image_url}"></div><div style="cursor:pointer;" class="info-row" id="infotitle-${
            record.uuid
          }"><h3>${
            record.title
          }</h3></div><div class="info-row"><h3 class="primary--text"><b>${
            record.price_total
          }</b> ${this.trans(
            "advert.price_currency_" + record.price_currency
          )}</h3></div></div>`;

          marker.addListener("click", () => {
            // Limit to only one ifo window
            if (this.active_popup) {
              this.active_popup.close();
              this.$emit("closeMarker");
            }
            // Save last popup
            this.active_popup = infoWindow;
            // Open window
            infoWindow.setContent(content);
            infoWindow.open(map, marker);

            this.$emit("clickMarker", record);
          });

          infoWindow.addListener("closeclick", () => {
            this.active_popup = null;
            this.$emit("closeMarker");
          });
          infoWindow.addListener("domready", () => {
            const box = document.querySelector(`#infowindow-${record.uuid}`);
            const title = document.querySelector(`#infotitle-${record.uuid}`);
            console.log("box", box);

            if (box) {
              box.addEventListener("click", () => {
                this.$emit("routeToItem", record.uuid);
              });
            }
            if (title) {
              title.addEventListener("click", () => {
                this.$emit("routeToItem", record.uuid);
              });
            }
          });

          marker.uuid = record.uuid;
        }

        marker.setMap(this.map);

        new_markers.push(marker);
      });

      _.forEach(this.rendered_markers, (existing_marker) => {
        existing_marker.setMap(null);
      });

      this.rendered_markers = new_markers;
    },

    // Debug
    drawRect: function (bounds) {
      if (this.rect) {
        this.rect.setMap(null);
      }
      var rectangle = new google.maps.Rectangle({
        strokeColor: "#888",
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: "#888",
        fillOpacity: 0.1,
        map: this.map,
        bounds: bounds,
      });

      this.rect = rectangle;
    },

    // Adds a marker to the map and push to the array.
    addMarker: function (location) {
      let options = Object.assign({}, location, { map: this.map });
      let marker = new google.maps.Marker(options);
    },

    // Proxy to google.map
    fitBounds: function (bounds, padding) {
      return this.map.fitBounds(bounds, padding);
    },

    getBounds: function () {
      return this.map.getBounds();
    },

    getCenter: function () {
      return this.map.getCenter();
    },

    getClickableIcons: function () {
      return this.map.getClickableIcons();
    },

    getDiv: function () {
      return this.map.getDiv();
    },

    getHeading: function () {
      return this.map.getHeading();
    },

    getMapTypeId: function () {
      return this.map.getMapTypeId();
    },

    getProjection: function () {
      return this.map.getProjection();
    },

    getStreetView: function () {
      return this.map.getStreetView();
    },

    getTilt: function () {
      return this.map.getTilt();
    },

    getZoom: function () {
      return this.map.getZoom();
    },

    panBy: function (x, y) {
      return this.map.panBy(x, y);
    },

    panTo: function (latLng) {
      return this.map.panTo(latLng);
    },

    panToBounds: function (latLngBounds, padding) {
      return this.map.panToBounds(latLngBounds, padding);
    },

    setCenter: function (latlng) {
      return this.map.setCenter(latlng);
    },

    setClickableIcons: function (value) {
      return this.map.setClickableIcons(value);
    },

    setHeading: function (heading) {
      return this.map.setHeading(heading);
    },

    setMapTypeId: function (mapTypeId) {
      return this.map.setMapTypeId(mapTypeId);
    },

    setOptions: function (options) {
      return this.map.setOptions(options);
    },

    setStreetView: function (panorama) {
      return this.map.setStreetView(panorama);
    },

    setTilt: function (tilt) {
      return this.map.setTilt(tilt);
    },

    setZoom: function (zoom) {
      return this.map.setZoom(zoom);
    },
  },
};
</script>